import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveConfig, saveOptionColor, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect, withColorRenderer, defaultRenderer } from '../common';

class LocalLabels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: []
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems
    });
  }

  handleColorChange = e => {
    this.props.saveOptionColor(e.optId, e.color);
  };

  handleChange = selected => {
    this.props.updateSelectedOptions(selected);
    this.props.saveConfig();
  };

  isEnabled = name => {
    return name === 'labels' || name === 'label' || name === 'priority' || name === 'tag' || name === 'work item type';
  };

  render() {
    const { items, selectedItems } = this.state;
    const { chart, enabledColorsLocal, enabledColors } = this.props;
    const colorsEnabled =
      chart === 'trc' || chart === 'ctb'
        ? this.isEnabled(enabledColorsLocal)
        : chart !== 'cfd' && enabledColors === 'labels';

    return (
      <CustomMultiselect
        name={'Labels'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
        fieldId={'labels'}
        itemRenderer={colorsEnabled ? withColorRenderer : defaultRenderer}
        colorsChangable={this.props.app === 'azure' || this.props.app === 'file'}
        onColorChange={this.handleColorChange}
      />
    );
  }
}

LocalLabels.propTypes = {};

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: vals => dispatch(updateSelectedOptions('labels', vals)),
    saveOptionColor: (optId, color) => dispatch(saveOptionColor('labels', optId, color))
  };
};

const mapStateToProps = state => {
  let chart = state.filters.chart;
  return {
    app: state.app.app,
    chart: state.filters.chart,
    enabledColors: state.filters.enabledColors,
    items: state.filters.allLabels,
    selectedItems: state.filters[chart].selectedLabels,
    enabledColorsLocal: state.filters[chart].enabledColors
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalLabels);
export { connected as LocalLabels, LocalLabels as TestLocalLabels };
